import React from 'react';
import clone from 'clone';
import ReactToggle from 'react-toggle';
import { findIndex } from 'underscore';
import Select from 'react-select';
import TaxonomySelection from '../helper/taxonomySelection';
import BuildActions from '../builder/action/builderActions';
import panelActions from './action/panelActions';
import GridSelect from '../element/gridselect';

class IsotopePanel extends React.Component {
    constructor(props) {
      super(props);
      this.handleTaxonomy = this.handleTaxonomy.bind(this);
      this.handleChangeDataTypes = this.handleChangeDataTypes.bind(this);
      this.valueIncrementLayout = this.valueIncrementLayout.bind(this);
      this.valueDecrementLayout = this.valueDecrementLayout.bind(this);
      this.onChangeSelectedImage = this.onChangeSelectedImage.bind(this);
      this.saveData = this.saveData.bind(this);
      this.datatypes = [
        {
          'label': 'Taxonomy',
          'value': 'taxonomies',
        },
      ];
      this.settings = {};
      this.state = {
        'allLayout': clone(this.props.allLayout),
        settings: {
          // 'numberOfPosts': 10,
          loadMoreOption: false,
          isotope_column: 2,
        },
      };
    }
    componentWillMount() {
      this.block = _.where(this.props.allLayout, { uid: this.props.uid });
      if (this.block) {
        this.block = this.block[0];
        this.setState({
          ...this.block,
          'settings': { ...this.state.settings, ...this.block },
        });
      }
    }
    componentWillReceiveProps(nextProps) {
      this.setState({
        'allLayout': clone(nextProps.allLayout),
        'settings': { ...this.state.settings, ...nextProps.settings },
      });
      this.settings = {};
    }
    valueIncrementLayout() {
      let value = null;
      if (this.state.settings.layout !== undefined) {
        value = parseInt(this.state.settings.layout, 10);
      } else {
        value = 12;
      }
      if ((value + 1) > 12) {
        return;
      }
      value += 1;
      this.state.settings.layout = value;
      this.setState({
        settings: { ...this.state.settings },
      });
    }
    valueDecrementLayout() {
      let value = null;
      if (this.state.settings.layout !== undefined) {
        value = parseInt(this.state.settings.layout, 10);
      } else {
        value = 12;
      }
      if ((value - 1) < 1) {
        return;
      }
      value -= 1;
      this.state.settings.layout = value;
      this.setState({
        settings: { ...this.state.settings },
      });
    }
    handleTaxonomy(val) {
      const value = val === null ? null : val.value;
      this.state.settings.selectedTaxonomy = value;
      this.setState({
        settings: { ...this.state.settings },
      });
    }
    handleChangeDataTypes(val) {
      const value = val === null ? null : val.value;
      this.state.settings.selectedDataType = value;
      this.setState({
        settings: { ...this.state.settings },
      });
    }
    handleColumnValueIncrement(element) {
      let value = null;
      if (this.state.settings[element] !== undefined) {
        value = parseInt(this.state.settings[element], 10);
      } else {
        value = 2;
      }
      if (element === 'isotope_column') {
        if ((value + 1) > 4) {
          return;
        }
      }
      value += 1;
      this.state.settings[element] = value;
      this.setState({
        settings: { ...this.state.settings },
      });
    }
    handleColumnValueDecrement(element) {
      let value = null;
      if (this.state.settings[element] !== undefined) {
        value = parseInt(this.state.settings[element], 10);
      } else {
        value = 2;
      }
      if ((value - 1) < 2) {
        return;
      }
      value -= 1;
      this.state.settings[element] = value;
      this.setState({
        settings: { ...this.state.settings },
      });
    }
    handleIsotopeBarClass(value) {
      const allLayout = this.props.allLayout;
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find].isotopeBarClass = value;
        this.setState({ isotopeBarClass: value, allLayout });
      }
      // this.setState({ allLayout });
    }
    handleWrapperClass(value) {
      const allLayout = this.props.allLayout;
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find].isotopeWrapperClass = value;
        this.setState({ isotopeWrapperClass: value, allLayout });
      }
      // this.setState({ allLayout });
    }
    onChangeSelectedImage(ImageId, type) {
      const allLayout = this.props.allLayout;
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find].previewLayouts = ImageId;
      }
      const pushLayout = {
        'allLayout': clone(allLayout),
        'shortcodeKey': this.props.shortcodeKey,
        reload: true,
      };
      BuildActions.saveAllBlocks(pushLayout);
    }
    saveData(e) {
      e.preventDefault();
      const allLayout = clone(this.props.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find] = Object.assign(allLayout[find], this.state.settings, this.state.allLayout[find]);
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
        reload: true,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);
      // location.reload();
    }

    render() {
      const self = this;
      const ImageId = [];
      const allLayout = this.props.allLayout;
      const find = findIndex(allLayout, { uid: this.props.uid });
      let viewType = null;
      if (find !== -1) {
        viewType = allLayout[find].hasOwnProperty('viewType') ? allLayout[find].viewType : null;
        if (allLayout[find].hasOwnProperty('previewLayouts')) {
          ImageId.push(allLayout[find].previewLayouts.toString());
        } else {
          ImageId.push('latestGridLayoutThree');
        }
      }
      const FilteredImageSelect = (item, index) => {
        if (item.data.length !== 0) {
          return (
            <div key = {index}>
              <GridSelect option = {item.data} defaultvalue= {ImageId} onImageSelcted = { this.onChangeSelectedImage } multiselect = "false" />
            </div>
          );
        }
      };
      this.filteredFormatData = [];
      if (this.props.helperData.formats !== undefined) {
        this.props.helperData.formats.map((item) => {
          if (item.toString() !== 'standard') {
            return;
          }
          const filteredFormat = {};
          filteredFormat.data = _.where(filteredFormat.data, { type: this.state.postTypes });
          const selfPostType = (this.state.postTypes) ? this.state.postTypes : 'post';
          filteredFormat.data = _.filter(ReactiveLayouts, function (sigleitem) {return sigleitem.type === selfPostType || sigleitem.type === 'all'; });
          if (filteredFormat.data.length === 0) {
            filteredFormat.data = _.where(ReactiveLayouts, { type: 'all' });
          }
          this.filteredFormatData.push(filteredFormat);
        });
      }
      return (<div>
         <button className="layout-save-button" onClick={this.saveData}><i className="fa fa-floppy-o"></i><span>{API.LANG.SAVE}</span></button>
         <div className="reactive-tab-setting">
            <ul className="nav nav-tabs" role="tablist">
              <li role="presentation" className="active"><a href="#general" aria-controls="general" role="tab" data-toggle="tab">{API.LANG.SETTINGS}</a></li>
              <li role="presentation"><a href="#layout" aria-controls="layout" role="tab" data-toggle="tab">{API.LANG.LAYOUT}</a></li>
              <li role="presentation"><a href="#column" aria-controls="column" role="tab" data-toggle="tab">{API.LANG.COLUMN}</a></li>
              <li role="presentation"><a href="#option" aria-controls="option" role="tab" data-toggle="tab">{API.LANG.OPTION}</a></li>
              <li role="presentation"><a href="#isotope-bar" aria-controls="isotope-bar" role="tab" data-toggle="tab">{API.LANG.BAR}</a></li>
            </ul>
            <div className="tab-content">
              <div role="tabpanel" className="tab-pane active" id="general">
                <div className="grid-choose-option">
                  <div className="flex-row">
                    <div className="flex-sm-3 flex-xs-12">
                      <span className="caption">{API.LANG.CHANGE_GRID_LAYOUT}</span>
                    </div>
                    <div className="flex-sm-9 flex-xs-12">
                      <div className="choose-grid-button">
                        <p><button onClick={ this.valueIncrementLayout }><i className="fa fa-plus"></i></button></p>
                        <p><button onClick={ this.valueDecrementLayout }><i className="fa fa-minus"></i></button></p>
                        <p className="gird-value-count">
                          { this.state.settings.layout !== undefined ? this.state.settings.layout : null }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div role="tabpanel" className="tab-pane" id="layout">
                <div className="grid-choose-option">
                  <span className="caption">{API.LANG.SELECT_ISOTOPE_TEMPLATE}</span>
                </div>
                { this.filteredFormatData.map(FilteredImageSelect) }
              </div>
              <div role="tabpanel" className="tab-pane" id="column">
                <div className="flex-row">
                  <div className="flex-sm-6">
                    <div className="grid-choose-option">
                      <div className="flex-row">
                        <div className="flex-sm-3 flex-xs-12">
                          <span className="caption">{API.LANG.ISOTOPE_COLUMN}</span>
                        </div>
                        <div className="flex-sm-9 flex-xs-12">
                          <p><button onClick={ this.handleColumnValueIncrement.bind(this, 'isotope_column') }><i className="fa fa-plus"></i></button></p>
                          <p><button onClick={ this.handleColumnValueDecrement.bind(this, 'isotope_column') }><i className="fa fa-minus"></i></button></p>
                          <p className="gird-value-count">
                            { this.state.settings.isotope_column !== undefined ? this.state.settings.isotope_column : 2 }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div role="tabpanel" className="tab-pane" id="option">
                <div className="grid-choose-option no-padding">
                  <div className="flex-row">
                    <div className="flex-sm-9 flex-xs-12">
                  <input type="text" value={this.state.settings.isotopeBarClass} className="reactive-input" onChange={ (node) => { this.handleIsotopeBarClass(node.target.value); }} placeholder={API.LANG.WRAPPER_CLASS_ISOTOPE_BAR}/>
                    </div>
                  </div>
                </div>
                <div className="grid-choose-option no-padding">
                  <div className="flex-row">
                    <div className="flex-sm-9 flex-xs-12">
                  <input type="text" value={this.state.settings.isotopeWrapperClass} className="reactive-input" onChange={ (node) => { this.handleWrapperClass(node.target.value); }} placeholder={API.LANG.WRAPPER_CLASS_ISOTOPE_GRID}/>
                    </div>
                  </div>
                </div>
              </div>
              <div role="tabpanel" className="tab-pane" id="isotope-bar">
                { /**
                  Please select data type
                */}
                <div className="flex-row">
                  <div className="flex-sm-6 flex-md-6">
                    <Select
                      name="form-field-name"
                      placeholder={API.LANG.PLEASE_ENTER_A_DATA_TYPE}
                      value={this.state.settings.selectedDataType}
                      options={this.datatypes}
                      onChange={this.handleChangeDataTypes}
                    />
                  </div>
                </div>
                  { this.state.settings.selectedDataType === 'taxonomies' ? <TaxonomySelection onTaxonomySelection={this.handleTaxonomy} value={this.state.settings.selectedTaxonomy} {...this.props} /> : null }
              </div>
            </div>

         </div>
      </div>);
    }

}
IsotopePanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'childUid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'settings': React.PropTypes.object,
};
export default IsotopePanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/isotopePanel.js
 **/